import { dashboardScrollMarginBelowTopBar } from "@/lib/layout/dashboard-sticky-top";

const MIN_TARGET_HEIGHT_PX = 24;

function isAdminDashboardPath(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.pathname.startsWith("/admin");
}

function isScrollTarget(element: HTMLElement): boolean {
  const style = window.getComputedStyle(element);
  if (style.display === "none" || style.visibility === "hidden") return false;
  if (style.position === "absolute" || style.position === "fixed") return false;
  const rect = element.getBoundingClientRect();
  return rect.height >= MIN_TARGET_HEIGHT_PX && rect.width > 0;
}

/** The block directly above the pager: the table, or its card on smaller screens. */
export function findPaginationTableTarget(
  paginationNav: HTMLElement,
): HTMLElement | null {
  let current: HTMLElement | null = paginationNav;

  while (current) {
    const parent: HTMLElement | null = current.parentElement;
    if (
      !parent ||
      parent === document.body ||
      parent === document.documentElement
    ) {
      return null;
    }

    const siblings = Array.from(parent.children);
    const index = siblings.indexOf(current);
    for (let i = index - 1; i >= 0; i -= 1) {
      const sibling = siblings[i];
      if (!(sibling instanceof HTMLElement)) continue;
      if (!isScrollTarget(sibling)) continue;
      return sibling;
    }

    if (parent.getAttribute("role") === "dialog") return null;
    current = parent;
  }

  return null;
}

export function scrollPaginationToTableTop(
  paginationNav: HTMLElement | null,
): void {
  if (!paginationNav || !isAdminDashboardPath()) return;

  const target = findPaginationTableTarget(paginationNav);
  if (!target) return;

  target.style.scrollMarginTop = dashboardScrollMarginBelowTopBar();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
}
